import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import React, { useEffect, useState } from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { SuggestProgramType } from '@src/api.types';
import { ToastProvider } from '@uhg-abyss/web/ui/Toast';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { SuggestProgramForm } from './SuggestProgramForm';
import { SuggestProgramUniteUs } from './SuggestProgramUniteUs';

export type SuggestAProgramProps = {
  programData: SuggestProgramType | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSaveProgram: (program: SuggestProgramType) => void;
  isEdit: boolean;
  listOfValidFields: string[];
  uniteUsRadio: string;
};

export const SuggestProgramModal = ({
  programData,
  isOpen,
  setIsOpen,
  onSaveProgram,
  isEdit,
  listOfValidFields = [],
  uniteUsRadio,
}: SuggestAProgramProps) => {
  const [isUniteUs, setUniteUs] = useState(false);
  const [isFindHelp, setFindHelp] = useState(isEdit);
  const [isUniteUsRadio, setIsUniteUsRadio] = useState(uniteUsRadio);

  const onSelectionChange = (e) => {
    const selection = e;
    if (selection !== undefined && selection === 'yes') {
      setUniteUs(true);
      setFindHelp(false);
      setIsUniteUsRadio(selection);
    }
    if (selection !== undefined && selection === 'no') {
      setFindHelp(true);
      setUniteUs(false);
      setIsUniteUsRadio(selection);
    }
  };

  return (
    <div>
      <ModalDialog
        closeOnClickOutside={false}
        size="$md"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div data-cy="suggest-program-modal">
          <div>
            <Heading level={5}>Suggest a program instructions</Heading>
            <div style={{ marginTop: '25px' }}>
              <RadioGroup
                label="Are you suggesting a program for MO, NC or NV?"
                onChange={(e) => {
                  onSelectionChange(e.target.value);
                }}
                value={isUniteUsRadio}
              >
                <RadioGroup.Column>
                  <RadioGroup.Radio label="Yes" value="yes" />
                  <RadioGroup.Radio label="No" value="no" />
                </RadioGroup.Column>
              </RadioGroup>
            </div>
            {isUniteUs && (
              <SuggestProgramUniteUs isOpen={isOpen} setIsOpen={setIsOpen} />
            )}
            {isFindHelp && (
              <SuggestProgramForm
                programData={programData}
                onSaveProgram={onSaveProgram}
                isEdit={isEdit}
                setModelOpen={(open) => setIsOpen(open)}
                listOfValidFields={listOfValidFields}
              />
            )}
          </div>
        </div>
      </ModalDialog>
      <ToastProvider children={undefined} />
    </div>
  );
};

SuggestProgramModal.defaultProps = {
  listOfValidFields: [],
};
